// React Hooks : `useEffect`, `useState`, and `useCallback` are imported from React for managing state and lifecycle events in a functional component.
import { gql, useQuery } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddVehicleAtBid from "../../../Pages/LoadEntry/AddVehicleAtBid";
import LoadDetails from "../../../Pages/LoadEntry/LoadDetails";
import Button from "../../Button/Button";
import Input from "../../Input/Input";
import { MultiSelectionComponent } from "../../MultiSelectionComponent/MultiSelectionComponent";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import { BidDetailsFields, BidFields, Textareadata } from "./AdddLoad.Config";
import "./Addload.scss";
import Addloadsection from "./Addloadsection/Addloadsection";
import BidResultsPage from "./BidResults";
import { checkErrors } from "./CheckError";
const GET_VEHICLE_CATEGORY = gql`
  query SearchVehicleCategory_With_VechileMasters($keyword: String!, $vehicleTypeId: ID) {
    searchVehicleCategory_With_VechileMasters(keyword: $keyword, Vehicle_Type_Id: $vehicleTypeId) {
      _id
      Unique_Id
      Name
      Search_Value
      Vehicle_Type
      User_ID
      createdAt
      updatedAt
    }
  }
`;

const GET_VEHICLE_TYPE = gql`
  query SearchVehicleTypeMasters($keyword: String) {
    searchVehicleTypeMasters(keyword: $keyword) {
      _id

      Search_Value
    }
  }
`;

const Get_Load_By_Id = gql`
  query loadByID($ID: ID) {
    loadByID(ID: $ID) {
      _id
      Unique_Id
      UserId {
        _id
        FullName
      }
      Load_Post_Type
      Auction_Date
      Auction_Time
      Dangerous_Goods
      Exact_Content
      Expected_Price
      From_City
      Load_Live_Duration
      Load_Manager {
        FullName
      }
      Loading_Area
      Loading_By
      Loading_City
      Loading_Date
      Loading_Landmark
      Loading_Name
      Loading_Pincode
      Loading_Scope
      Loading_State
      Loading_Time
      Loading_Town
      Loading_Address_Line_1
      Loading_Address_Line_2
      Material_Category
      Material_Dimension
      Material_Dimension_In
      Material_Insurence
      Material_Image
      Material_Image_2
      Material_Image_3
      No_Of_Vehicels_Required
      No_Of_Vehicels_Loading_Completed
      Notes
      Over_Dimension_Cargo
      Payment_Type {
        _id
        Name
      }
      Rate_per
      Target_Price
      To_City
      Total_Weight
      Unloading_Area
      Unloading_City
      Unloading_Landmark
      Unloading_Name
      Unloading_Pincode
      Unloading_Scope
      Unloading_State
      Unloading_Town
      Unloading_Address_Line_1
      Unloading_Address_Line_2
      Vehicle_Category {
        _id
        Search_Value
      }
      VehicleCategoryGroupData {
        _id
        VehicleType
        VehicleCategory {
          _id
          Unique_Id
          Name
          User_ID
          createdAt
          updatedAt
        }
      }
      Private_Group_ID {
        _id
      }
      Private_Contact_ID {
        _id
      }
      Post_To_Private_Network
      Post_To_EMT_Load_Board
      Is_Live
      Is_Auction_Started
      Is_Archive
      createdAt
      updatedAt
    }
  }
`;

const BidDetails = ({ fielddata, show, LoadId, totalWeight, setShowModal, TypeOfPortal }) => {
  let { data, loading, error, refetch } = useQuery(Get_Load_By_Id, {
    variables: { ID: LoadId },
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });
  // ### State Management
  // - Various `useState` hooks are used for local state management, including:
  //   - `openItems` and `showBidResultsPage` for controlling UI visibility,
  const [selectedVehicleTypesWithCategories, setSelectedVehicleTypesWithCategories] = useState({ 1: {}, 2: {}, 3: {} });
  const [selectedVehicleTypes, setSelectedVehicleTypes] = useState([]);

  const [openItems, setOpenItems] = useState(show);
  const [showBidResultsPage, setShowBidResultsPage] = useState(false);
  const [openMultiSelect, setMultiselectModal] = useState(false);
  //   - `allFieldsData` and `notesdata` for managing form data and notes related to the bid,
  const [allFieldsData, setAllFieldsData] = useState({});
  const [fieldCount, setFieldCount] = useState(1);
  const [notesdata, setNotesdata] = useState("");
  const [loadData, setLoadData] = useState({});
  const [totalQuantity, setTotalQuantity] = useState(0);
  const Index = useRef(null);
  //   - `showAddVehicleModal` for managing the visibility of a modal related to vehicle management,
  const [showAddVehicleModal, setShowAddVehicleModal] = useState(false);
  const FormData = useSelector((store) => store.FormFieldData);
  const dispatch = useDispatch();
  const BidAmount = FormData?.fielddata?.User_Details_For_Bid?.Bid;
  const vehicleQuantities = [
    FormData?.fielddata?.Vehicle_Fields?.Enter_Quantity,
    FormData?.fielddata?.Vehicle_Fields2?.Enter_Quantity,
    FormData?.fielddata?.Vehicle_Fields3?.Enter_Quantity,
  ];
  const [showErrors, SetShowErrors] = useState(false);
  const Redux_Error = useSelector((store) => store.FormFieldData?.Errors);

  useEffect(() => {
    if (data) {
      setLoadData(data.loadByID[0]);
    }
  }, [data]);
  useEffect(() => {
    dispatch({ type: "Clear_Errors" });
  }, []);
  let calculateIndividualBids = () => {
    if (loadData?.Load_Post_Type === "Fixed Load") {
      if (loadData.Rate_per === "Per MT") {
        return vehicleQuantities
          .slice(0, fieldCount)
          .map((quantity) => (Number(quantity) || 0) * (Number(loadData?.Target_Price) || 0));
      } else {
        return vehicleQuantities.slice(0, fieldCount).map((quantity) => Number(loadData?.Target_Price));
      }
    } else {
      if (loadData?.Rate_per === "Per MT") {
        return vehicleQuantities
          .slice(0, fieldCount)
          .map((quantity) => (Number(quantity) || 0) * (Number(BidAmount) || 0));
      } else {
        return vehicleQuantities.slice(0, fieldCount).map((quantity) => Number(BidAmount));
      }
    }
  };
  const Closeformfunction2 = () => {
    setShowModal();
    setOpenItems(false);
    setShowBidResultsPage(false);
    dispatch({ type: "ClearData", payload: { data: {} } });
  };

  let submit = () => {
    // Check for errors
    const errors = checkErrors(Redux_Error);
    if (errors) {
      SetShowErrors(true);
      return;
    } else if (loadData.Rate_per === "Per Vehicle" && !(BidAmount % 100 === 0)) {
      ErrorToast("Bid Amount should be in multiple of 100");
      return;
    }
    if (loadData.Rate_per === "Per MT" && !(BidAmount % 10 === 0)) {
      ErrorToast("Bid Amount should be in multiple of 10");
      return;
    }
    setShowBidResultsPage(true);
  };

  useEffect(() => {
    if (loadData?.Load_Post_Type == "Fixed Load") {
      setAllFieldsData({
        No_Of_Vehicles: 1,
        Bid: loadData.Target_Price,
        ...fielddata,
      });
    } else {
      setAllFieldsData({ No_Of_Vehicles: 1, ...fielddata });
    }
  }, [fielddata, loadData]);
  useEffect(() => {
    if (FormData?.fielddata?.Bidding_Fields?.No_Of_Vehicles) {
      setFieldCount(FormData?.fielddata?.Bidding_Fields?.No_Of_Vehicles);
    }
  }, [FormData?.fielddata?.Bidding_Fields?.No_Of_Vehicles]);

  // Calculating based on the selection of number of vehicles
  useEffect(() => {
    let total = 0;

    for (let key in selectedVehicleTypesWithCategories) {
      let num = selectedVehicleTypesWithCategories[key]?.Total_Weight;
      if (num) {
        total += Number(num);
      }
    }

    setTotalQuantity(total);
  }, [selectedVehicleTypesWithCategories]);

  useEffect(() => {
    if (allFieldsData && allFieldsData.Notes) {
      setNotesdata(allFieldsData.Notes);
    }
  }, [allFieldsData]);

  const handleVehicleTypeCheckboxChange = (vehicleType, category, check) => {
    let type = selectedVehicleTypesWithCategories[Index.current];
    // let updatedData = type?.filter(el => el._id !== category._id) || []
    // if (check) {
    //   updatedData.push(category)
    // }
    // let Prev = selectedVehicleTypesWithCategories[Index.current]
    // setSelectedVehicleTypesWithCategories((prev) => {
    //   return { ...prev, [Index.current]: { ...Prev, [vehicleType.Search_Value]: updatedData } }
    // })
    setSelectedVehicleTypesWithCategories((prev) => {
      return { ...prev, [Index.current]: { ...type, category } };
    });
    if (selectedVehicleTypes.includes(category?._id)) {
      // If selected, remove it from the list
      setSelectedVehicleTypes((prevSelected) => prevSelected.filter((id) => id !== category?._id));
    } else {
      // If not selected, add it to the list
      setSelectedVehicleTypes((prevSelected) => [...prevSelected, category?._id]);
    }
  };
  return (
    <Reactportal open={openItems} onClose={Closeformfunction2} TypeOfPortal={"Bid Details"}>
      <div className="mainBidDetailsdiv">
        {/* 
      `LoadDetails` component is rendered to display specific details about the load being bid on, 
      indicating this is a critical piece of information for the bidder. 
      */}
        <LoadDetails LoadId={LoadId} Type={"Bidding"} />
        <div className="BiddingPage">
          <div className="BidDetailsMainContainer">
            <div className="Alloadmaindiv">
              <div className="BiddingPage">
                <div className="VehicleFields">
                  <div>
                    <p style={{ textAlign: "center" }}>
                      Confirm Quantity(MT) {`${totalQuantity}/MT`} {loadData ? `${loadData?.Total_Weight}/MT` : "0/MT"}
                    </p>
                  </div>

                  {BidDetailsFields.map((e, i) => {
                    return (
                      <Addloadsection
                        showErrors={showErrors}
                        fields={e.fields}
                        BidType={loadData?.Load_Post_Type == "Fixed Load" ? true : false}
                        Type={e.name}
                        fielddata={allFieldsData}
                        TypeOfPortal={TypeOfPortal}
                      />
                    );
                  })}
                </div>
                {BidFields.map((e, i) => {
                  return (
                    <Addloadsection
                      showErrors={showErrors}
                      fields={e.fields}
                      Type={e.name}
                      fielddata={allFieldsData}
                      TypeOfPortal={TypeOfPortal}
                    />
                  );
                })}
                {Array.from({ length: fieldCount }, (_, index) => (
                  <div className="VehicleFields1">
                    <div className="buttonContainer">
                      <Button
                        name="modalbutton"
                        text={
                          selectedVehicleTypesWithCategories[index + 1]?.category?.Search_Value || "Vehicle Category"
                        }
                        action={() => {
                          Index.current = index + 1;
                          setMultiselectModal(true);
                        }}
                      />
                    </div>
                    <Input
                      label="Total Weight"
                      modalform={true}
                      handleBlur={() => {}}
                      name="Total_Weight"
                      type={"number"}
                      value={selectedVehicleTypesWithCategories[index + 1]?.Total_Weight}
                      handleInputChange={(e) => {
                        let type = selectedVehicleTypesWithCategories[Index.current];
                        setSelectedVehicleTypesWithCategories((prev) => {
                          return { ...prev, [Index.current]: { ...type, Total_Weight: e.target.value } };
                        });
                      }}
                      InputConfig={{ type: "number", isRequired: false }}
                    />
                  </div>
                ))}

                {openMultiSelect && (
                  <MultiSelectionComponent
                    storeSelectedData={handleVehicleTypeCheckboxChange}
                    show={openMultiSelect}
                    Closeformfunction={() => setMultiselectModal(false)}
                    selectedData={selectedVehicleTypesWithCategories[Index.current]?.category?._id}
                    handleCancle={() => setMultiselectModal(false)}
                    firstLevelQuery={GET_VEHICLE_TYPE}
                    secondLevelQuery={GET_VEHICLE_CATEGORY}
                  />
                )}
              </div>

              {Textareadata.map((e, i) => {
                return (
                  <Addloadsection
                    fields={e.fields}
                    Type={e.name}
                    fielddata={allFieldsData}
                    TypeOfPortal={TypeOfPortal}
                  />
                );
              })}
            </div>
          </div>

          {showBidResultsPage && (
            <BidResultsPage
              show={true}
              totalWeight={loadData && loadData.Total_Weight}
              LoadId={LoadId}
              individualBids={calculateIndividualBids()}
              setShowModal={setShowBidResultsPage}
              TypeOfPortal={"Bid Results"}
              vehicleData={selectedVehicleTypesWithCategories}
            />
          )}
        </div>

        {showAddVehicleModal && (
          <AddVehicleAtBid
            show={showAddVehicleModal}
            id={""}
            TypeOfPortal={"Add"}
            submitType={""}
            ParentPortalCloseFunction={() => setShowAddVehicleModal(false)}
          />
        )}
      </div>

      <PortalFooter
        renderContent={() => <></>}
        disabled={false}
        submitform={submit}
        submitType={"Save"}
        handleformclose={() => {
          Closeformfunction2();
          setOpenItems(false);
        }}
      />
    </Reactportal>
  );
};

export default BidDetails;
